import styled from "styled-components";

import { BackLink as PrimitiveBackLink } from "ds/Button";
import * as Tabs from "ds/Tabs";

import * as DrawerLayout from "./components/DrawerLayout.styles";

export const BackLink = styled(PrimitiveBackLink)`
  margin-bottom: 0;
`;

export const TabRoot = styled(Tabs.Root)`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 1px;
`;

export const TabContent = styled(Tabs.Content)`
  display: flex;
  flex: 1;
  padding-top: 32px;
  padding-bottom: 22px;
  position: relative;
  min-height: 1px;
  &[data-state="inactive"] {
    display: none;
  }
`;

export const DrawerContent = styled(DrawerLayout.Content)`
  display: flex;
`;
